import React, { useState, useContext, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Typography,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import Input from "@mui/joy/Input";
import axios from "axios";
import { AppContext } from "../../../context/AppContext";
import BASE_URL from "../../../config/api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ThemeProvider } from "@emotion/react";
import theme from "../../../themes/theme";
import "./EditSection.css";
import AdminLayout from "../../../components/AdminDashboard/AdminLayout/AdminLayout";

export default function EditSection() {
  const { id } = useParams();
  const [sectionTitle, setSectionTitle] = useState("");
  const [success, setSuccess] = useState("");
  const [sections, setSections] = useState([]);
  const [loadingSections, setLoadingSections] = useState(true);
  const [editMode, setEditMode] = useState(false);
  const [editingSection, setEditingSection] = useState(null);
  const { token } = useContext(AppContext);
  const navigate = useNavigate();

  const handleAddLesson = (id, sectionId) => {
    navigate(`/courses/${id}/sections/${sectionId}/lessons`);
  };

  const handleCreateSection = async () => {
    try {
      if (editMode) {
        await axios.put(
          `${BASE_URL}/courses/${id}/sections/${editingSection._id}`,
          { title: sectionTitle },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        setSuccess("Section updated successfully!");
        setEditMode(false);
      } else {
        try {
          await axios.post(
            `${BASE_URL}/courses/${id}/sections`,
            { title: sectionTitle },
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            }
          );
          setSuccess("Section created successfully!");
          toast.success("Section created successfully!");
        } catch (err) {
          toast.error(err.response.data);
          setSuccess("");
        }
      }

      if (token) {
        fetchSections();
      }
    } catch (err) {
      toast.error(err.response.data);
      setSuccess("");
    }
  };

  const handleEditSection = (section) => {
    setEditingSection(section);
    setSectionTitle(section.title);
    setEditMode(true);
  };

  const fetchSections = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/courses/${id}/sections`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setSections(response.data);

      setLoadingSections(false);
    } catch (err) {
      setLoadingSections(false);
    }
  };

  useEffect(() => {
    if (token) {
      fetchSections();
    }
  }, [id, token]);

  return (
    <AdminLayout>
      <div className="create-form-wrapper">
        <div className="edit-section-form">
          <label>Section title</label>
          <div className="input-section-container">
            <Input
              variant="soft"
              label="Title"
              value={sectionTitle}
              onChange={(e) => setSectionTitle(e.target.value)}
            />

            <ThemeProvider theme={theme}>
              <Button
                sx={{ height: "50px" }}
                variant="contained"
                onClick={handleCreateSection}
              >
                {editMode ? "Update Section" : "Create Section"}
              </Button>
            </ThemeProvider>
          </div>
        </div>
      </div>

      {success && (
        <Typography color="success" sx={{ marginTop: 2 }}>
          {success}
        </Typography>
      )}

      <p className="title">Sections of this course</p>
      {loadingSections ? (
        <CircularProgress />
      ) : (
        <TableContainer
          component={Paper}
          sx={{ maxWidth: "600px", margin: "auto" }}
        >
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: "600" }}>Section Title</TableCell>
                <TableCell sx={{ fontWeight: "600" }}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {sections.map((section) => (
                <TableRow key={section._id}>
                  <TableCell sx={{ padding: "20px", maxWidth: "60%" }}>
                    {editMode && editingSection?._id === section._id ? (
                      <Input
                        variant="soft"
                        label="Title"
                        value={sectionTitle}
                        onChange={(e) => setSectionTitle(e.target.value)}
                      />
                    ) : (
                      section.title
                    )}
                  </TableCell>
                  <TableCell>
                    <ThemeProvider theme={theme}>
                      {editMode && editingSection?._id === section._id ? (
                        <Button
                          variant="contained"
                          sx={{ marginRight: "10px" }}
                          onClick={handleCreateSection}
                        >
                          Update Section
                        </Button>
                      ) : (
                        <>
                          <Button
                            sx={{ marginRight: "10px" }}
                            variant="outlined"
                            onClick={() => handleEditSection(section)}
                          >
                            Edit section
                          </Button>
                          <Button
                            sx={{ marginRight: "10px" }}
                            variant="contained"
                            onClick={() => handleAddLesson(id, section._id)}
                          >
                            Edit/Add lesson
                          </Button>
                          {/* 
                          <Button
                            variant="contained"
                            color="error"
                            startIcon={<DeleteIcon />}
                            onClick={() => handleDeleteSection(id, section._id)}
                          >
                            Delete
                          </Button> */}
                        </>
                      )}
                    </ThemeProvider>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
      />
    </AdminLayout>
  );
}
